import Handler from "@/core/domain/usecase/handler";

const createServiceOrderRepository = (axios) => async (data) => {
    try {
        const response = await axios.post(`/service-order`, data)
        return response.data
    } catch (error) {
        if(error.isAxiosError) {
            throw new Handler().trataErro(error)
        } else {
            throw error
        }
    }
}

export default createServiceOrderRepository